import React from 'react';
// Components
import Banner from '../../../components/Banner/Banner';
import './VakumSistemleri.css';

const VakumSistemleri = () => {
  return (
    <div className="vakum-sistemleri-page">
      {/* Main Content */}
      
      {/* Banner */}
      <Banner 
        title="Vakum Sistemleri" 
        backgroundImage={require('../../../assets/images/inner-banner.jpg')} 
      />

      {/* Page Content */}
      <section className="vakum-sistemleri-content">
        <div className="container content-container">
          {/* Section 1: System Overview */}
          <div className="section overview">
            <h4 className="section-heading">
              Vakumda Buharlaştırıcı VE-100 İnce Film Kaplama, Metalizasyon Ünitesi
            </h4>
          </div>

          {/* Section 2: Key Features */}
          <div className="section features">
            <div className="row">
              <div className="column">
                <p>
                  Hafif, portatif ve sade tasarımı sayesinde ince filmlerin hızlıca kaplanabildiği bir masa üstü vakum sistemi. 
                  Sistemde kullanılan turbomoleküler pompa ile 10⁻⁶ Torr’a, yağsız geri pompalı sistem ile atmosferden 10⁻⁷ Torr’a ulaşılmaktadır. 
                  Ayrıca alüminyum, altın, gümüş gibi malzemeler kolayca kaplanabilmekte ve 200 amper’e kadar akım uygulanabilen güç kaynağı ile desteklenmektedir.
                </p>
              </div>
              <div className="column">
                <img 
                  src={require('../../../assets/images/021EAB6C-1B64-47E9-91A0-CE6E26A98F93.jpeg')} 
                  alt="Vakum Sistemi Key Features" 
                  className="img-fluid"
                />
              </div>
            </div>
          </div>

          {/* Section 3: Electrical Feedthrough */}
          <div className="section feedthrough">
            <div className="row">
              <div className="column">
                <img 
                  src={require('../../../assets/images/AF3280DF-1A22-4A61-AD88-D75F363FA720.jpeg')} 
                  alt="Electrical Feedthrough" 
                  className="img-fluid"
                />
              </div>
              <div className="column">
                <h4>Electrical Feedthrough</h4>
                <p>
                  Yüksek vakum odacığına elektriksel bağlantı sağlayan feedthrough, kaplamanın temiz kalmasını destekleyen pota üzeri kapatıcı (shutter) ve 
                  ayarlanabilir örnek tutucu ile entegre çalışır.
                </p>
              </div>
            </div>
          </div>

          {/* Section 4: Modular Vacuum Chamber */}
          <div className="section modular-chamber">
            <h4 className="section-heading">
              Vakum Sistemleri Modüler Termal Buharlaştırma ve Mıknatıssal Saçtırma Vakum Odacıkları
            </h4>
            <p>
              Bu sistem, çift taraflı olarak kullanılabilen modüler yapısı sayesinde, vakum ortamı bozulmadan katman-katman termal buharlaştırma 
              ve aynı anda üç farklı malzemenin co-deposition’ını mümkün kılar.
            </p>
          </div>

          {/* Section 5: Magnetron Sputtering System */}
          <div className="section sputtering">
            <div className="row">
              <div className="column">
                <img 
                  src={require('../../../assets/images/pasted-image-1.jpg')} 
                  alt="Magnetron Sputtering System" 
                  className="img-fluid"
                />
              </div>
              <div className="column">
                <h5>Magnetron Sputtering System</h5>
                <p>
                  İntensif ince film kaplamaları için DC veya RF ile çalışabilen, 2 inç hedefler için tasarlanmış MSG2 tabanlı bir saçtırma kaynağı.
                </p>
                <p>
                  Fiyat: 2500 USD + KDV <br />
                  (Opsiyonlar: shutter, manyetik hedef kaplama, sabit veya değişken açılı eğik seçenekleri ek ücret karşılığında uygulanır.)
                </p>
              </div>
            </div>
          </div>

          {/* Section 6: Magnetron Power Supply */}
          <div className="section power-supply">
            <div className="row">
              <div className="column">
                <h5>Mıknatıssal Saçtırma Güç Kaynağı (1 kW)</h5>
                <p>
                  TEKNOMA VN-1001P, 2 inç ile 4 inç arası kaynaklar için özel olarak tasarlanmış olup, dijital ekran, ayar düğmesi, 
                  otomatik plazma uyarısı ve UHF çıkışlı kablo özelliklerine sahiptir.
                </p>
                <ul>
                  <li>1 kW DC güç</li>
                  <li>Ark önleme ve akım ayarı</li>
                  <li>Dijital ekranlı kontrol paneli</li>
                  <li>220V, 1 faz çalışır</li>
                </ul>
                <p>Fiyat: 2500 USD + KDV</p>
              </div>
              <div className="column">
                <img 
                  src={require('../../../assets/images/021EAB6C-1B64-47E9-91A0-CE6E26A98F93.jpeg')} 
                  alt="Magnetron Power Supply" 
                  className="img-fluid"
                />
              </div>
            </div>
          </div>
          
        </div>
      </section>

    </div>
  );
};

export default VakumSistemleri;
